import React from 'react';
import { t } from '@citrite/translate';
import { Button, palette, WorkspaceLogoIcon } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import {
	CardDivStyle,
	StyledAlertAction,
	StyledAlertContent,
	StyledAlertSection,
	StyledStatus,
	StyledStatusText,
} from 'App/ProgressAlert/LaunchProgressAlert.styles';

const StyledCard = styled.div`
	${CardDivStyle}
	border-top: 1px solid ${palette.grey200};
	background-color: ${palette.grey100};
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	width: auto;
`;

const StyledStatusFooter = styled(StyledStatus)`
	font-weight: 600;
	font-size: 14px;
	line-height: 100%;
	color: ${palette.black};
`;

interface Props {
	onClose: () => void;
	activeLaunchsCount: number;
}
export function WaitAlert({ onClose, activeLaunchsCount }: Props) {
	return (
		<StyledCard data-testid="wait-alert">
			<StyledAlertContent>
				<WorkspaceLogoIcon data-testid="workspace-logo-icon" size={27} />
				<StyledAlertSection>
					<StyledStatus>
						{activeLaunchsCount > 0 ? (
							<StyledStatusText data-testid="status-text">
								{activeLaunchsCount > 1
									? t('Workspace:wait_for_multiple_launches')
									: t('Workspace:wait_for_single_launch')}
							</StyledStatusText>
						) : (
							<StyledStatusFooter>
								{t('Workspace:apps_and_desktop_launch.workspace_app')}
							</StyledStatusFooter>
						)}
					</StyledStatus>
				</StyledAlertSection>
			</StyledAlertContent>
			<StyledAlertAction>
				<Button.SubtlePrimary
					disabled={activeLaunchsCount > 0}
					onClick={() => {
						onClose();
					}}
				>
					{t('Workspace:close_all')}
				</Button.SubtlePrimary>
			</StyledAlertAction>
		</StyledCard>
	);
}
